import { render, staticRenderFns } from "./ListGroups.vue?vue&type=template&id=49433516&scoped=true&"
import script from "./listGroups.ts?vue&type=script&lang=ts&"
export * from "./listGroups.ts?vue&type=script&lang=ts&"
import style0 from "./ListGroups.vue?vue&type=style&index=0&id=49433516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49433516",
  null
  
)

export default component.exports